/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import Video, { type VideoProps } from 'components/Video/Video';
import Statement from '../Statement/Statement';
import './StatementVideo.scss';

const DEFAULT_VIDEO: VideoProps = {};

interface StatementVideoProps {
  statement?: string;
  video?: VideoProps;
}

/**
 * This is the StatementVideo component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function StatementVideo({
  statement = '',
  video = DEFAULT_VIDEO,
}: StatementVideoProps) {
  return (
    <div className="statement-video">
      <Statement>{statement}</Statement>
      <div className="video-container">
        <Video {...video} />
      </div>
    </div>
  );
}

export default StatementVideo;
